import React, { useState } from "react";

const ListingImage = ({ url }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [showFullImage, setShowFullImage] = useState(false);

  const handleImageClick = () => {
    setShowFullImage(true);
  };
  return (
    <div className="h-[550px]">
      {!imageLoaded && (
        <div className="w-full h-full object-cover object-center flex justify-center items-center">
          <img
            src="/assets/loader/loader.png"
            alt=""
            className="flex justify-center items-center w-full max-w-[40px]"
          />
        </div>
      )}
      {/* {showFullImage && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-95 flex justify-center items-center z-50"
          onClick={() => setShowFullImage(false)}
        >
          <img src={url} alt="Full Image" className="max-w-full max-h-full" />
        </div>
      )} */}
      {/* <div
        className="h-[550px]"
        style={{
          background: `url(${url}) center no-repeat`,
          backgroundSize: "cover",
        }}
        onLoad={() => setImageLoaded(true)}
      ></div> */}
      <img
        src={url}
        onLoad={() => setImageLoaded(true)}
        style={{
          width: "100%",
          height: "550px",
          objectFit: "cover",
        }}
        // onClick={handleImageClick}
      />
    </div>
  );
};

export default ListingImage;
